module.exports = "<h1>Welcome back, <span class=\"user-name-display\"></span>!</h1>\n"